import * as IconNames from '../constants/IconNames';

export enum IconSize {
  SMALL = 12,
  MEDIUM = 16,
  DEFAULT = 24,
}

export type IconName = typeof IconNames[keyof typeof IconNames];

export type IconContentFunction = (
  props: {
    size: number;
    color: string;
  }
) => JSX.Element;
